import React from 'react';
import TextoTruncavel from './TextoTruncavel';

// Visão "sem gráfico" pedida explicitamente — mesma exigência que a skill
// de dataviz já cobra como item de acessibilidade obrigatório (toda tela
// com gráfico precisa de uma visão em tabela equivalente). Única/múltipla
// escolha vira tabela numérica (opção, contagem, %); texto aberto NÃO vira
// tabela de frequência de palavra — isso ainda seria "palavra listada", que
// foi pedido pra tirar do gerenciador. Pergunta aberta aqui é só a lista
// completa das respostas reais, cada uma com truncamento + "Ver mais".
const TabelaDadosBrutos = ({ perguntas }) => (
  <div className="space-y-5">
    {perguntas.map((pergunta) => {
      if (pergunta.tipo === 'aberta') {
        return (
          <div key={pergunta.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6">
            <h3 className="text-base font-semibold text-gray-900 mb-1">{pergunta.texto}</h3>
            <p className="text-xs text-gray-400 mb-3">{pergunta.totalRespostas} resposta(s) de texto</p>

            {!pergunta.respostas || pergunta.respostas.length === 0 ? (
              <p className="text-sm text-gray-400 italic">Nenhuma resposta registrada ainda.</p>
            ) : (
              <ul className="space-y-1.5 max-h-96 overflow-y-auto pr-1">
                {pergunta.respostas.map((texto, indice) => (
                  <li key={indice} className="text-sm text-gray-700 bg-gray-50 rounded-lg px-3 py-2">
                    <TextoTruncavel texto={texto} />
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      }

      const ordenados = [...(pergunta.itens || [])].sort((a, b) => b.votos - a.votos);
      const total = pergunta.totalRespostas;

      return (
        <div key={pergunta.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6">
          <h3 className="text-base font-semibold text-gray-900 mb-1">{pergunta.texto}</h3>
          <p className="text-xs text-gray-400 mb-3">{total} respondente(s)</p>

          {ordenados.length === 0 ? (
            <p className="text-sm text-gray-400 italic">Nenhum dado registrado ainda.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs font-semibold uppercase tracking-wide text-gray-400 border-b border-gray-100">
                    <th className="py-2 pr-3 font-semibold">Opção</th>
                    <th className="py-2 pr-3 font-semibold text-right">Contagem</th>
                    <th className="py-2 font-semibold text-right">%</th>
                  </tr>
                </thead>
                <tbody>
                  {ordenados.map((item) => {
                    const percentual = total > 0 ? Math.round((item.votos / total) * 1000) / 10 : 0;
                    return (
                      <tr key={item.slug} className="border-b border-gray-50 last:border-0">
                        <td className="py-2 pr-3 text-gray-700">{item.label}</td>
                        <td className="py-2 pr-3 text-right font-medium text-gray-900">{item.votos.toLocaleString('pt-BR')}</td>
                        <td className="py-2 text-right text-gray-500">{percentual}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export default TabelaDadosBrutos;
